// extracted by mini-css-extract-plugin
module.exports = {"comp":"BannerC_comp__U_Tiv"};